import { SOHO_ENTITY_DATABASE } from '../data/executiveSohoEntityDatabase'

export const COMP_SET_MATCH_DIMENSIONS = [
  { key: 'geographic', label: 'Geographic proximity' },
  { key: 'tier', label: 'Service tier' },
  { key: 'scale', label: 'Comparable scale' },
]

export const PROPERTY_BENCHMARK_PROFILES = {
  huntington: {
    market: 'San Francisco, CA',
    metro: 'san-francisco',
    serviceTier: 'Lifestyle & Luxury',
    roomCount: 135,
    starRating: 4.5,
    preloadedCompSetIds: ['entity-fairmont-sf', 'entity-ritz-sf', 'entity-four-seasons-sf'],
  },
  newbury: {
    market: 'Boston, MA',
    metro: 'boston',
    serviceTier: 'Lifestyle & Luxury',
    roomCount: 286,
    starRating: 5,
    preloadedCompSetIds: ['entity-fairmont-boston', 'entity-ritz-boston'],
  },
  joule: {
    market: 'Dallas, TX',
    metro: 'dallas',
    serviceTier: 'Lifestyle & Luxury',
    roomCount: 160,
    starRating: 4.5,
    preloadedCompSetIds: ['entity-rosewood-dallas', 'entity-ritz-dallas'],
  },
  'park-lane': {
    market: 'New York, NY',
    metro: 'new-york',
    serviceTier: 'Lifestyle & Luxury',
    roomCount: 282,
    starRating: 5,
    preloadedCompSetIds: ['entity-plaza-nyc', 'entity-ritz-nyc'],
  },
  alohilani: {
    market: 'Honolulu, HI',
    metro: 'honolulu',
    serviceTier: 'Resort',
    roomCount: 421,
    starRating: 4.5,
    preloadedCompSetIds: ['entity-halekulani', 'entity-royal-hawaiian'],
  },
  paracas: {
    market: 'Paracas, Peru',
    metro: 'paracas',
    serviceTier: 'Resort',
    roomCount: 120,
    starRating: 4.5,
    preloadedCompSetIds: ['entity-hotel-paracas-comp', 'entity-doubletree-paracas'],
  },
  'tambo-del-inka': {
    market: 'Sacred Valley, Peru',
    metro: 'sacred-valley',
    serviceTier: 'Resort',
    roomCount: 128,
    starRating: 5,
    preloadedCompSetIds: ['entity-inkaterra', 'entity-belmond-valle'],
  },
  marker: {
    market: 'Dublin, Ireland',
    metro: 'dublin',
    serviceTier: 'Resort',
    roomCount: 187,
    starRating: 4,
    preloadedCompSetIds: null,
  },
  'westin-lima': {
    market: 'Lima, Peru',
    metro: 'lima',
    serviceTier: 'Full Service',
    roomCount: 301,
    starRating: 4.5,
    preloadedCompSetIds: ['entity-swissotel-lima', 'entity-hilton-lima'],
  },
  'courtyard-vegas': {
    market: 'Las Vegas, NV',
    metro: 'las-vegas',
    serviceTier: 'Select Service',
    roomCount: 149,
    starRating: 3.5,
    preloadedCompSetIds: ['entity-hampton-vegas', 'entity-fairfield-vegas'],
  },
  'home2-longmont': {
    market: 'Longmont, CO',
    metro: 'longmont-co',
    serviceTier: 'Select Service',
    roomCount: 95,
    starRating: 3,
    preloadedCompSetIds: null,
  },
  'four-points-fw': {
    market: 'Fort Walton Beach, FL',
    metro: 'fort-walton-beach',
    serviceTier: 'Select Service',
    roomCount: 132,
    starRating: 3,
    preloadedCompSetIds: null,
  },
}

const EXTENDED_COMPETITOR_CANDIDATES = [
  ...SOHO_ENTITY_DATABASE,
  {
    id: 'entity-fairmont-sf',
    property: 'Fairmont San Francisco',
    type: 'Luxury Hotel',
    location: 'San Francisco, CA',
    brand: 'Fairmont',
    subBrand: 'San Francisco',
    serviceTier: 'Lifestyle & Luxury',
    metro: 'san-francisco',
    roomCount: 591,
    starRating: 4.5,
  },
  {
    id: 'entity-ritz-sf',
    property: 'The Ritz-Carlton, San Francisco',
    type: 'Luxury Hotel',
    location: 'San Francisco, CA',
    brand: 'Ritz-Carlton',
    subBrand: 'San Francisco',
    serviceTier: 'Lifestyle & Luxury',
    metro: 'san-francisco',
    roomCount: 336,
    starRating: 5,
  },
  {
    id: 'entity-four-seasons-sf',
    property: 'Four Seasons Hotel San Francisco',
    type: 'Luxury Hotel',
    location: 'San Francisco, CA',
    brand: 'Four Seasons',
    subBrand: 'San Francisco',
    serviceTier: 'Lifestyle & Luxury',
    metro: 'san-francisco',
    roomCount: 277,
    starRating: 5,
  },
  {
    id: 'entity-fairmont-boston',
    property: 'Fairmont Copley Plaza',
    type: 'Luxury Hotel',
    location: 'Boston, MA',
    brand: 'Fairmont',
    subBrand: 'Copley Plaza',
    serviceTier: 'Lifestyle & Luxury',
    metro: 'boston',
    roomCount: 383,
    starRating: 4.5,
  },
  {
    id: 'entity-ritz-boston',
    property: 'The Ritz-Carlton, Boston',
    type: 'Luxury Hotel',
    location: 'Boston, MA',
    brand: 'Ritz-Carlton',
    subBrand: 'Boston',
    serviceTier: 'Lifestyle & Luxury',
    metro: 'boston',
    roomCount: 193,
    starRating: 5,
  },
  {
    id: 'entity-rosewood-dallas',
    property: 'Rosewood Mansion on Turtle Creek',
    type: 'Luxury Hotel',
    location: 'Dallas, TX',
    brand: 'Rosewood',
    subBrand: 'Turtle Creek',
    serviceTier: 'Lifestyle & Luxury',
    metro: 'dallas',
    roomCount: 143,
    starRating: 5,
  },
  {
    id: 'entity-ritz-dallas',
    property: 'The Ritz-Carlton, Dallas',
    type: 'Luxury Hotel',
    location: 'Dallas, TX',
    brand: 'Ritz-Carlton',
    subBrand: 'Dallas',
    serviceTier: 'Lifestyle & Luxury',
    metro: 'dallas',
    roomCount: 218,
    starRating: 5,
  },
  {
    id: 'entity-plaza-nyc',
    property: 'The Plaza Hotel',
    type: 'Luxury Hotel',
    location: 'New York, NY',
    brand: 'Fairmont',
    subBrand: 'The Plaza',
    serviceTier: 'Lifestyle & Luxury',
    metro: 'new-york',
    roomCount: 282,
    starRating: 5,
  },
  {
    id: 'entity-ritz-nyc',
    property: 'The Ritz-Carlton New York, Central Park',
    type: 'Luxury Hotel',
    location: 'New York, NY',
    brand: 'Ritz-Carlton',
    subBrand: 'Central Park',
    serviceTier: 'Lifestyle & Luxury',
    metro: 'new-york',
    roomCount: 259,
    starRating: 5,
  },
  {
    id: 'entity-halekulani',
    property: 'Halekulani',
    type: 'Luxury Resort',
    location: 'Honolulu, HI',
    brand: 'Independent',
    subBrand: 'Waikiki',
    serviceTier: 'Resort',
    metro: 'honolulu',
    roomCount: 453,
    starRating: 5,
  },
  {
    id: 'entity-royal-hawaiian',
    property: 'The Royal Hawaiian',
    type: 'Luxury Resort',
    location: 'Honolulu, HI',
    brand: 'Luxury Collection',
    subBrand: 'Waikiki',
    serviceTier: 'Resort',
    metro: 'honolulu',
    roomCount: 528,
    starRating: 5,
  },
  {
    id: 'entity-hotel-paracas-comp',
    property: 'DoubleTree Resort by Hilton Paracas',
    type: 'Beach Resort',
    location: 'Paracas, Peru',
    brand: 'DoubleTree',
    subBrand: 'Paracas',
    serviceTier: 'Resort',
    metro: 'paracas',
    roomCount: 124,
    starRating: 4,
  },
  {
    id: 'entity-doubletree-paracas',
    property: 'Aranwa Paracas Resort & Spa',
    type: 'Beach Resort',
    location: 'Paracas, Peru',
    brand: 'Aranwa',
    subBrand: 'Paracas',
    serviceTier: 'Resort',
    metro: 'paracas',
    roomCount: 115,
    starRating: 4.5,
  },
  {
    id: 'entity-inkaterra',
    property: 'Inkaterra Hacienda Urubamba',
    type: 'Luxury Resort',
    location: 'Sacred Valley, Peru',
    brand: 'Inkaterra',
    subBrand: 'Sacred Valley',
    serviceTier: 'Resort',
    metro: 'sacred-valley',
    roomCount: 105,
    starRating: 5,
  },
  {
    id: 'entity-belmond-valle',
    property: 'Belmond Hotel Rio Sagrado',
    type: 'Luxury Resort',
    location: 'Sacred Valley, Peru',
    brand: 'Belmond',
    subBrand: 'Sacred Valley',
    serviceTier: 'Resort',
    metro: 'sacred-valley',
    roomCount: 121,
    starRating: 5,
  },
  {
    id: 'entity-swissotel-lima',
    property: 'Swissôtel Lima',
    type: 'Full Service Hotel',
    location: 'Lima, Peru',
    brand: 'Swissôtel',
    subBrand: 'Lima',
    serviceTier: 'Full Service',
    metro: 'lima',
    roomCount: 246,
    starRating: 4.5,
  },
  {
    id: 'entity-hilton-lima',
    property: 'Hilton Lima Miraflores',
    type: 'Full Service Hotel',
    location: 'Lima, Peru',
    brand: 'Hilton',
    subBrand: 'Miraflores',
    serviceTier: 'Full Service',
    metro: 'lima',
    roomCount: 329,
    starRating: 4.5,
  },
  {
    id: 'entity-hampton-vegas',
    property: 'Hampton Inn Las Vegas',
    type: 'Select Service Hotel',
    location: 'Las Vegas, NV',
    brand: 'Hampton Inn',
    subBrand: 'Las Vegas',
    serviceTier: 'Select Service',
    metro: 'las-vegas',
    roomCount: 129,
    starRating: 3,
  },
  {
    id: 'entity-fairfield-vegas',
    property: 'Fairfield Inn Las Vegas',
    type: 'Select Service Hotel',
    location: 'Las Vegas, NV',
    brand: 'Fairfield Inn',
    subBrand: 'Las Vegas',
    serviceTier: 'Select Service',
    metro: 'las-vegas',
    roomCount: 148,
    starRating: 3,
  },
  {
    id: 'entity-hampton-longmont',
    property: 'Hampton Inn Longmont',
    type: 'Select Service Hotel',
    location: 'Longmont, CO',
    brand: 'Hampton Inn',
    subBrand: 'Longmont',
    serviceTier: 'Select Service',
    metro: 'longmont-co',
    roomCount: 88,
    starRating: 3,
  },
  {
    id: 'entity-fairfield-longmont',
    property: 'Fairfield Inn Longmont',
    type: 'Select Service Hotel',
    location: 'Longmont, CO',
    brand: 'Fairfield Inn',
    subBrand: 'Longmont',
    serviceTier: 'Select Service',
    metro: 'longmont-co',
    roomCount: 92,
    starRating: 3,
  },
  {
    id: 'entity-hampton-fw',
    property: 'Hampton Inn Fort Walton Beach',
    type: 'Select Service Hotel',
    location: 'Fort Walton Beach, FL',
    brand: 'Hampton Inn',
    subBrand: 'Fort Walton Beach',
    serviceTier: 'Select Service',
    metro: 'fort-walton-beach',
    roomCount: 118,
    starRating: 3,
  },
  {
    id: 'entity-fairfield-fw',
    property: 'Fairfield Inn Fort Walton Beach',
    type: 'Select Service Hotel',
    location: 'Fort Walton Beach, FL',
    brand: 'Fairfield Inn',
    subBrand: 'Fort Walton Beach',
    serviceTier: 'Select Service',
    metro: 'fort-walton-beach',
    roomCount: 126,
    starRating: 3,
  },
  {
    id: 'entity-fitzpatrick-dublin',
    property: 'The Fitzwilliam Hotel Dublin',
    type: 'Luxury Hotel',
    location: 'Dublin, Ireland',
    brand: 'Independent',
    subBrand: 'Dublin',
    serviceTier: 'Resort',
    metro: 'dublin',
    roomCount: 172,
    starRating: 4.5,
  },
  {
    id: 'entity-shelbourne-dublin',
    property: 'The Shelbourne, Autograph Collection',
    type: 'Luxury Hotel',
    location: 'Dublin, Ireland',
    brand: 'Marriott',
    subBrand: 'Shelbourne',
    serviceTier: 'Resort',
    metro: 'dublin',
    roomCount: 265,
    starRating: 5,
  },
]

const CANDIDATE_BY_ID = new Map(EXTENDED_COMPETITOR_CANDIDATES.map((entity) => [entity.id, entity]))

const inferServiceTier = (entity) => {
  if (entity.serviceTier) return entity.serviceTier
  const type = String(entity.type || '').toLowerCase()
  if (type.includes('select') || type.includes('limited')) return 'Select Service'
  if (type.includes('resort') || type.includes('beach')) return 'Resort'
  if (type.includes('luxury') || type.includes('boutique')) return 'Lifestyle & Luxury'
  return 'Full Service'
}

const inferMetro = (entity) => {
  if (entity.metro) return entity.metro
  return String(entity.location || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
}

const normalizeCandidate = (entity) => ({
  ...entity,
  serviceTier: inferServiceTier(entity),
  metro: inferMetro(entity),
  roomCount: Number(entity.roomCount) || 200,
  starRating: Number(entity.starRating) || 4,
})

const isComparableScale = (propertyProfile, candidate) => {
  const propertyRooms = Number(propertyProfile.roomCount) || 0
  const candidateRooms = Number(candidate.roomCount) || 0
  if (!propertyRooms || !candidateRooms) return true

  const roomRatio = candidateRooms / propertyRooms
  const roomMatch = roomRatio >= 0.35 && roomRatio <= 2.75
  const starMatch = Math.abs(candidate.starRating - propertyProfile.starRating) <= 1
  return roomMatch && starMatch
}

const scoreCandidate = (propertyProfile, candidate) => {
  const roomDelta = Math.abs(candidate.roomCount - propertyProfile.roomCount)
  const starDelta = Math.abs(candidate.starRating - propertyProfile.starRating)
  return roomDelta + starDelta * 40
}

const buildCompetitorEntry = (candidate, propertyProfile, matchSource) => {
  const normalized = normalizeCandidate(candidate)
  const dimensions = {
    geographic: normalized.metro === propertyProfile.metro,
    tier: normalized.serviceTier === propertyProfile.serviceTier,
    scale: isComparableScale(propertyProfile, normalized),
  }

  return {
    id: normalized.id,
    name: normalized.property,
    subline: [normalized.brand, normalized.location].filter(Boolean).join(' · '),
    location: normalized.location,
    serviceTier: normalized.serviceTier,
    roomCount: normalized.roomCount,
    starRating: normalized.starRating,
    matchDimensions: dimensions,
    matchSummary: buildMatchSummary(dimensions),
    matchSource,
  }
}

export function buildMatchSummary(dimensions) {
  const labels = COMP_SET_MATCH_DIMENSIONS.filter((dimension) => dimensions[dimension.key]).map(
    (dimension) => dimension.label
  )
  return labels.length ? labels.join(' · ') : 'Partial match'
}

export function resolvePropertyBenchmarkProfile(propertyId, brandLabel) {
  const profile = PROPERTY_BENCHMARK_PROFILES[propertyId]
  if (profile) return { ...profile }

  return {
    market: 'Portfolio market',
    metro: `tier-${String(brandLabel || 'unknown').toLowerCase().replace(/[^a-z0-9]+/g, '-')}`,
    serviceTier: brandLabel || 'Full Service',
    roomCount: 180,
    starRating: 4,
    preloadedCompSetIds: null,
  }
}

export function suggestPropertyCompSet(propertyProfile, { maxCompetitors = 4 } = {}) {
  const normalizedProfile = {
    ...propertyProfile,
    serviceTier: propertyProfile.serviceTier,
    metro: propertyProfile.metro,
    roomCount: Number(propertyProfile.roomCount) || 180,
    starRating: Number(propertyProfile.starRating) || 4,
  }

  const matches = EXTENDED_COMPETITOR_CANDIDATES.map(normalizeCandidate)
    .filter((candidate) => candidate.serviceTier === normalizedProfile.serviceTier)
    .filter((candidate) => candidate.metro === normalizedProfile.metro)
    .filter((candidate) => isComparableScale(normalizedProfile, candidate))
    .sort(
      (left, right) => scoreCandidate(normalizedProfile, left) - scoreCandidate(normalizedProfile, right)
    )
    .slice(0, maxCompetitors)
    .map((candidate) => buildCompetitorEntry(candidate, normalizedProfile, 'suggested'))

  return matches
}

export function buildPropertyCompSet(propertyId, brandLabel, { maxCompetitors = 4 } = {}) {
  const profile = resolvePropertyBenchmarkProfile(propertyId, brandLabel)

  if (profile.preloadedCompSetIds?.length) {
    const competitors = profile.preloadedCompSetIds
      .map((id) => CANDIDATE_BY_ID.get(id))
      .filter(Boolean)
      .map((candidate) => buildCompetitorEntry(candidate, profile, 'activesocial'))

    return {
      competitors,
      meta: {
        source: 'activesocial',
        sourceLabel: 'Preloaded from ActiveSocial',
        profile,
        matchDimensions: {
          geographic: true,
          tier: true,
          scale: true,
        },
        matchSummary: 'Geographic proximity · Service tier · Comparable scale',
        competitorCount: competitors.length,
        isSuggested: false,
      },
    }
  }

  const competitors = suggestPropertyCompSet(profile, { maxCompetitors })

  return {
    competitors,
    meta: {
      source: 'suggested',
      sourceLabel: 'Auto-suggested by SOHO',
      profile,
      matchDimensions: {
        geographic: true,
        tier: true,
        scale: true,
      },
      matchSummary: 'Matched on geographic proximity, service tier, and comparable scale',
      competitorCount: competitors.length,
      isSuggested: true,
    },
  }
}

export function formatPropertyCompSetScope(profile) {
  if (!profile) return ''
  return `${profile.market} · ${profile.serviceTier} · ${profile.roomCount} rooms · ${profile.starRating}★`
}
